var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLenses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 61,
    height: 61,
    rx: 30.5,
    fill: "url(#paint0_linear_61_7128)",
    stroke: "url(#paint1_linear_61_7128)",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6998 20.265C42.0089 23.5381 38.2073 28.3851 33.2858 33.3025C28.3084 38.2757 23.4031 42.1044 20.1265 43.7645C23.8625 45.7928 31.5772 46.0452 38.9662 38.6624C46.1895 31.4451 45.7265 24.1637 43.6998 20.265ZM16.2553 42.8022C16.9229 39.8351 21.3443 33.7549 27.5414 27.563C33.6616 21.4479 39.6728 17.0633 42.6814 16.3129C43.2895 15.8422 44.1676 15.9061 44.7001 16.4807C48.7212 20.8199 50.6274 31.2518 41.0884 40.7828C31.664 50.1993 20.5763 49.1652 16.3995 44.6581C15.917 44.1374 15.8748 43.3662 16.2553 42.8022ZM31.1636 31.1821C27.5353 34.8073 24.0015 37.7505 21.2147 39.624C23.0897 36.8395 26.0353 33.3087 29.6636 29.6834C33.2919 26.0582 36.8257 23.115 39.6125 21.2415C37.7375 24.026 34.7918 27.5568 31.1636 31.1821Z",
    fill: "url(#paint2_linear_61_7128)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_7128",
    x1: 56.96,
    y1: 0.00000108547,
    x2: -6.34387,
    y2: 28.1671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04B6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E75FD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_61_7128",
    x1: 13.44,
    y1: -3.58094e-8,
    x2: 7.13874,
    y2: 61.1063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_61_7128",
    x1: 22.7199,
    y1: 16,
    x2: 19.5698,
    y2: 46.5505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLenses);
export default __webpack_public_path__ + "static/media/lenses.edf3030d686596f26076b87cf9b60304.svg";
export { ForwardRef as ReactComponent };